function initEnv() {
  window.__APP_CONFIG__ = {
    REACT_APP_ENVIRONMENT: ensure("REACT_APP_ENVIRONMENT", process.env.REACT_APP_ENVIRONMENT),
    REACT_APP_CLIENT_ID: ensure("REACT_APP_CLIENT_ID", process.env.REACT_APP_CLIENT_ID),
    REACT_APP_REDIRECT_URI: ensure("REACT_APP_REDIRECT_URI", process.env.REACT_APP_REDIRECT_URI),
    REACT_APP_LOGOUT_URI: ensure("REACT_APP_LOGOUT_URI", process.env.REACT_APP_LOGOUT_URI),
    REACT_APP_AUTHORITY: ensure("REACT_APP_AUTHORITY", process.env.REACT_APP_AUTHORITY),
    PUBLIC_URL: ensure("PUBLIC_URL", process.env.PUBLIC_URL),
    REACT_APP_BACKEND_URL: ensure("REACT_APP_BACKEND_URL", process.env.REACT_APP_BACKEND_URL),
    REACT_APP_FLOW_ACCESS_TOKEN_SCOPE: ensure(
      "REACT_APP_FLOW_ACCESS_TOKEN_SCOPE",
      process.env.REACT_APP_FLOW_ACCESS_TOKEN_SCOPE
    ),
    REACT_APP_CUSTOMERSERVICE_URL: ensure(
      "REACT_APP_CUSTOMERSERVICE_URL",
      process.env.REACT_APP_CUSTOMERSERVICE_URL
    ),
    REACT_APP_LEAKDETECTOR_URL: ensure(
      "REACT_APP_LEAKDETECTOR_URL",
      process.env.REACT_APP_LEAKDETECTOR_URL
    ),
    REACT_APP_OPERATIONS_URL: ensure(
      "REACT_APP_OPERATIONS_URL",
      process.env.REACT_APP_OPERATIONS_URL
    ),
    REACT_APP_INSTALLATIONS_URL: ensure(
      "REACT_APP_INSTALLATIONS_URL",
      process.env.REACT_APP_INSTALLATIONS_URL
    ),
    REACT_APP_ALERTS_URL: ensure("REACT_APP_ALERTS_URL", process.env.REACT_APP_ALERTS_URL),
    REACT_APP_NEM_URL: ensure("REACT_APP_NEM_URL", process.env.REACT_APP_NEM_URL),
    REACT_APP_MY_KAMSTRUP: ensure("REACT_APP_MY_KAMSTRUP", process.env.REACT_APP_MY_KAMSTRUP),
    REACT_APP_LEAK_API_V1_URL: ensure(
      "REACT_APP_LEAK_API_V1_URL",
      process.env.REACT_APP_LEAK_API_V1_URL
    ),
    REACT_APP_AI_APPNAME: ensure("REACT_APP_AI_APPNAME", process.env.REACT_APP_AI_APPNAME),
    REACT_APP_AI_INSTRUMENTATION_KEY: ensure(
      "REACT_APP_AI_INSTRUMENTATION_KEY",
      process.env.REACT_APP_AI_INSTRUMENTATION_KEY
    ),
    REACT_APP_BUILD_VERSION: ensure("REACT_APP_BUILD_VERSION", process.env.REACT_APP_BUILD_VERSION),
    REACT_APP_ANALYTICS_ACCESS_TOKEN_SCOPE: ensure(
      "REACT_APP_ANALYTICS_ACCESS_TOKEN_SCOPE",
      process.env.REACT_APP_ANALYTICS_ACCESS_TOKEN_SCOPE
    ),
    REACT_APP_BE_REFRESH_INTERVAL: ensure(
      "REACT_APP_BE_REFRESH_INTERVAL",
      process.env.REACT_APP_BE_REFRESH_INTERVAL
    )
  };
}

function ensure(key: string, value: string | undefined) {
  if (!value) {
    console.warn(`environmental variable ${key} not set`);
    return `[Warning] ${key} missing`;
  }

  return value;
}

export function getEnv(): typeof window.__APP_CONFIG__ {
  if (!window.__APP_CONFIG__) {
    initEnv();
  }

  return window.__APP_CONFIG__;
}
